// extracted by mini-css-extract-plugin
export default {"container":"styles__container--gJvT-","visa":"styles__visa--kbH2C","mc":"styles__mc--I4dgY","amex":"styles__amex--pf88k","discover":"styles__discover--iSxjN"};